<template>
	<div class="wms-detail-item wms-mb10" :style="{display: 'inline-block', width: groupWidth+'px', overflow: 'hidden',height:18+'px'}">
		<div class="text-right" :style="{width: labelWidth+'px',position: 'absolute'}">{{label}}</div>
		<div class="float-left text-left" :style="{marginLeft: labelWidth+'px', marginRight: '0px'}">
			<slot>

			</slot>
		</div>
	</div>
</template>

<script>
export default {
    name: 'detailItem',
    props: ['label', 'labelWidth', 'groupWidth']
}
</script>
